import { Box, Button, Flex, Heading, Image, Text } from "@chakra-ui/react";
import React from "react";
import privacy from "../../assets/SHIPPING & DELIVERY POLICY.jpg";

const ShippingNdelivery = () => {
  return (
    <Box w={"100%"} textAlign={"left"}>
      <Image src={privacy} w={"100%"} />
      <Box px={14} py={10}>
        <Heading color={"#3C375F"} mt={5} className="oswald-font">
          Shipping & Delivery policy
        </Heading>
        <Text
          color={"#3C375F"}
          fontWeight={"bold"}
          fontSize={20}
          mt={4}
          className="oswald-font"
        >
          Shipping information
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className={"lato-font"}
        >
          We’re thrilled that you’re excited to receive your order from Wishfy.
          We’ve got you covered with a reliable network of couriers to deliver
          your products as quickly as possible.
        </Text>
        <Text
          color={"#3C375F"}
          fontWeight={"bold"}
          fontSize={20}
          mt={10}
          className={"oswald-font"}
        >
          Order process:
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className={"lato-font"}
        >
          * You’ll receive an order confirmation email once you place your
          order.
          <br />* After we ship your order, you’ll get a tracking link via
          email.
        </Text>
        <Text
          color={"#3C375F"}
          fontWeight={"bold"}
          fontSize={20}
          mt={10}
          className={"oswald-font"}
        >
          Shipping timeline:
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className={"lato-font"}
        >
          * It takes about 3 days to ship your product after order confirmation.
          <br />* Delivery usually takes 5-10 business days to reach your
          doorstep.
        </Text>
        <Text
          color={"#3C375F"}
          fontWeight={"bold"}
          fontSize={20}
          mt={10}
          className={"oswald-font"}
        >
          Free shipping:
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className={"lato-font"}
        >
          * Enjoy free shipping on orders above Rs 499.
        </Text>
        <Text
          color={"#3C375F"}
          fontWeight={"bold"}
          fontSize={20}
          mt={10}
          className={"oswald-font"}
        >
          Delivery variations:
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className={"lato-font"}
        >
          * The delivery time may vary depending on your location.
        </Text>
        <Text
          color={"#3C375F"}
          fontWeight={"bold"}
          fontSize={20}
          mt={10}
          className={"oswald-font"}
        >
          Order updates:
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className={"lato-font"}
        >
          * We’ll keep you informed every step of the way via Email/SMS.
          <br />* You’ll receive the order tracking link via email after your
          order is shipped.
        </Text>
        <Text
          color={"#3C375F"}
          fontWeight={"bold"}
          fontSize={20}
          mt={10}
          className={"oswald-font"}
        >
          Special time-bound requests:
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className={"lato-font"}
        >
          If you have specific time-bound delivery requests, please email us at
          support@wishfy.io with your preferred delivery time, and we’ll do our
          best to accommodate.
        </Text>
        <Text
          color={"#3C375F"}
          fontWeight={"bold"}
          fontSize={20}
          mt={10}
          className={"oswald-font"}
        >
          Coverage considerations:
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className={"lato-font"}
        >
          While we work with some of India’s best logistics companies, there may
          be locations they don’t serve. If your address is in such an area,
          we’ll contact you to find an alternative solution to ensure your
          products reach you.
        </Text>
        <Text
          color={"#3C375F"}
          fontWeight={"bold"}
          fontSize={20}
          mt={10}
          className={"oswald-font"}
        >
          Need assistance?
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className={"lato-font"}
        >
          * If you’re unsure about your order’s status, feel free to write to us
          at support@wishfy.io.
        </Text>
        <Text
          color={"#3C375F"}
          fontWeight={"bold"}
          fontSize={20}
          mt={10}
          className={"oswald-font"}
        >
          International shipping:
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className={"lato-font"}
        >
          * Currently, we do not offer international shipping.
        </Text>
        <Text
          color={"#3C375F"}
          fontWeight={"bold"}
          fontSize={20}
          mt={10}
          className={"oswald-font"}
        >
          Customer feedback:
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className={"lato-font"}
        >
          * If you’ve had anything less than a satisfying shopping experience
          with us, please reach out and let us know why at support@wishfy.io. We
          are committed to making your space uniquely yours, starting right
          here.
        </Text>
        <Text color={"#200E32"} fontSize={"14px"} mt={5} lineHeight={1.2}>
          We appreciate your trust in Wishfy, and we’re dedicated to delivering
          your products to you promptly. If you have any questions or concerns,
          don’t hesitate to contact us at support@wishfy.io. Your satisfaction
          is our priority. here.
        </Text>
      </Box>
    </Box>
  );
};

export default ShippingNdelivery;
